import {
  Box,
  ButtonDanger,
  ButtonLight,
  Modal,
  Text
} from 'front-end/src/components/'
import React, { FC } from 'react'

import { t, Trans } from '@lingui/macro'

import Loader from '../../../components/common/loader/Loader'
import { notification } from '../../../components/common/notifications/Notifications'
import { usePathwayRelatedInstancesQuery } from '../../manage-pathway-page/ManagePathwayPage.codegen'
import { usePathwayArchiveMutation } from './PathwayDeleteModal.codegen'
import { PathwayRelatedInstances } from './PathwayRelatedInstances'

export const PathwayDeleteModal: FC<{
  onCanceled: () => void
  pathwayId: number | null
  onDeleted?: () => void
  show?: boolean
}> = ({ onCanceled, pathwayId, onDeleted, show }) => {
  if (!pathwayId) {
    return null
  }

  const [deletePathway] = usePathwayArchiveMutation()
  const { data, loading } = usePathwayRelatedInstancesQuery({
    variables: { id: pathwayId }
  })

  const pathway = data?.admin?.pathway

  if (!pathway || loading) {
    return <Loader />
  }

  const disableArchivation =
    pathway?.relatedCertifications &&
    pathway?.relatedCertifications.length +
      pathway?.relatedCampaignsByFilters.length +
      pathway?.relatedCampaignsByActions.length

  if (disableArchivation) {
    return (
      <Modal
        newDesign
        header={t`Unable to archive pathway`}
        show={show}
        controls={[
          <ButtonLight onClick={onCanceled} key={1}>
            <Trans>Cancel</Trans>
          </ButtonLight>
        ]}
        onHide={onCanceled}
      >
        <Box mb="16px">
          <Text className={`Modal__relatedItems__importantInfo`}>
            <Trans>
              This pathway cannot be archived as it appears in the following
              instances.
            </Trans>
          </Text>
          <Text className={`Modal__relatedItems__importantInfo`}>
            <Trans>
              Should you still wish to archive this pathway, please update the
              relevant item or contact their owner.
            </Trans>
          </Text>
        </Box>

        <PathwayRelatedInstances pathway={pathway} />
      </Modal>
    )
  }

  return (
    <Modal
      newDesign
      header={t`Are you sure you want to archive this pathway?`}
      show={show}
      controls={[
        <ButtonLight onClick={onCanceled} key={1}>
          <Trans>Cancel</Trans>
        </ButtonLight>,
        <ButtonDanger
          key={2}
          onClickAsync={async () => {
            await deletePathway({
              variables: { id: pathwayId }
            })
            onDeleted && onDeleted()
            notification.info(t`Pathway successfully archived.`)
          }}
        >
          <Trans>Archive pathway</Trans>
        </ButtonDanger>
      ]}
    >
      <Text className={`Modal__relatedItems__importantInfo`}>
        <Trans>
          Access to this pathway will be removed for
          <strong> everyone. This action cannot be undone.</strong>
        </Trans>
      </Text>

      <PathwayRelatedInstances pathway={pathway} />
    </Modal>
  )
}
